const GET_PAYMENT_DOC = "GET_PAYMENT_DOC"
const GET_PAYMENT_DOC_SUCCESS = "GET_PAYMENT_DOC_SUCCESS"
const GET_PAYMENT_DOC_FAIL = "GET_PAYMENT_DOC_FAIL"

const BASE_ENDPOINT = '/Document/';
const initialValues = {
    loading: false,
    hasError: false,
    data: null
};

const voucherDocument = (state = initialValues, action) => {

    switch (action.type) {

        case GET_PAYMENT_DOC: {
            return {
                ...state,
                data: action.payload.request.url,
                loading: true,
            }
        }

        case GET_PAYMENT_DOC_SUCCESS: {
            return {
                ...state,
                loading: false,
            }
        }

        case GET_PAYMENT_DOC_FAIL: {
            return {
                ...state,
                loading: false,
                hasError: true,
            };
        }

        default: {
            return state;
        }

    }
};

export const getPaymentDoc = (companyCode, compensDoc, vendorNum, compensationDateId) => {

    return {
        type: GET_PAYMENT_DOC,
        payload: {
            request: {
                method: "GET",
                url: BASE_ENDPOINT + `GetDocPayment?COMPANY_CODE=${companyCode}&COMPENS_DOC=${compensDoc}&VENDOR_NUM=${vendorNum}&COMPENSATION_DATE_ID=${compensationDateId}`,
                //HARDCODED
                //url: BASE_ENDPOINT + `GetDocPayment?COMPANY_CODE=AR02&COMPENS_DOC=0033521579&VENDOR_NUM=0000800160&COMPENSATION_DATE_ID=20190102`,
            },
        },
    };
};

export default voucherDocument;